import { getAvailableReportTableRetrieveLoader } from "gen/endpoints/reports/reports";
import { RouteObject } from "react-router-dom";

const reportRoutes: RouteObject = {
  id: "reports",
  path: "reports",
  children: [
    {
      id: "availableReportsList",
      index: true,
      lazy: async () => {
        const { ReportsTablePage } = await import(
          "features/reports/ReportsTablePage"
        );
        return { Component: ReportsTablePage };
      },
      loader: getAvailableReportTableRetrieveLoader(),
    },
  ],
};

export default reportRoutes;
